(function() {
    'use strict';

    /**
     * @ngdoc service
     * @name common.service:ProuctClass
     * @description
     */

    angular.module('itxApp.common').factory('Product', productClass);

    productClass.$inject = [
        'ItxUtilsFct', 
        'ItxConstants', 
        'ItxScreenSizeSvc',
        'CmsConfigSvc',
        'ItxConfigurationSvc',
        'ProductLayoutSvc',
        'mdUtils'
    ];

    function productClass(
        ItxUtilsFct, 
        ItxConstants, 
        ItxScreenSizeSvc,
        CmsConfigSvc,
        ItxConfigurationSvc,
        ProductLayoutSvc,
        mdUtils
    ) {
        var indice = 1;
        var uniqueId = 1;
        const isExplorer = inditex.isExplorer();
        // Obtiene la propiedad de dias de novedad de la configuración
        var configDays = 7;
        CmsConfigSvc.getProperty('new_label_days').then(function(days) {
            configDays = days || 7;
        });  

        function Product(product, colorId, parent, category, sku, defaultSet) {                        
            this.isBundleBean = false;
            this.categoryId = category ? category : inditex.iCategoryId;
            this._uniqueId = uniqueId;
            uniqueId++;
            this.fetched = false;
            this.isRelated = false;
            this.state = {
                selectedColorIndex: 0,
                selectedSizeIndex: 0,
                selectedColor: null,
                selectedSize: null,
                xcustomization: false,
                isBanner: false,
                isFakeBanner: false,
                isCarrousel: false,
                isProduct: true,
                configDays: configDays,
                locationImgCarrousel: 'relatedProduct'
            };
            this.activeDetail = {};

            if(defaultSet){
                this.activeDetail.xmediaDefaultSet = defaultSet;
                if(colorId){
                    this.state.idSetColor = colorId;
                }
            }
            
            // _extend hereda todas propiedades del producto en el nuevo THIS
            if (typeof product === 'object') {
                _.extend(this, product);
            } else {
                this.id = product;
            }

            if(typeof product !== 'number' && product.availability){
                this.availability = product.availability;
            }

            if(product && product.detail && product.detail.colors && product.detail.colors.length>0) {
                // PRIORITY 1 - Productos de un bundle que tienen color seleccionado de Gesticor 
                this.pendingColor = product.detail.colors[0].id;
            } else if(parent && parent.isBundleBean && parent.bundleColors.length>0 && !colorId) {
                // PRIORITY 2 - Productos de un bundle pueden heredar colores del padre
                this.pendingColor = parent.bundleColors[0].id;
            } else if(product && product.state && product.state.selectedColor && !colorId) {
                // PRIORITY 3 - Si venimos de parrilla ya tenemos selectedColor
                this.pendingColor = product.state.selectedColor.id;
            } else {
                // PRIORITY 4 - Sino cumple con lo anterior agregamos el colorId por parametro
                this.pendingColor = colorId;
            }

            if (sku) {
                // PRIORITY 4 - Cuando creamos un new Item de wishlist solo tenemos categntryId que es el sku del producto (MOCACOTA)
                this.sku = sku;
            }
            
            this.setElementType();
            this.setCategoryPagevisibility();
            
            if (typeof product === 'object') {
                this.applyAllPriceLogic();
                this.setConfigProduct();
            }
            if(this.name){
                this.name = mdUtils.firstCapitalLetter(this.name);
            }
            return this;
        }
        
        Product.prototype.fetch = function() {
            var _this = this;
            if (this.fetched) {
                return new Promise(resolve => {
                    resolve(_this);
                });
            } 
            else {
                return new joyr.catalog.Product(this.id).then(function(product) {
                    _.extend(_this, product.product);
                    _.extend(_this, product.stock);
                    _this.setElementType();  
                    _this.fetched = true;
                    _this.isPerfum();
                    _this.setXmediaDefaultSet();
                    //_this.setCategoryPagevisibility();
                    _this.applyAllPriceLogic();
                    _this.setConfigProduct();
                    return _this;
                });
            }
        };

        Product.prototype.setCategoryPagevisibility = function() {
            this.categoryPageVisibility = this.visibility === joyr.constants.visibility.SHOW_VISIBILITY || 
                                          this.visibility === joyr.constants.visibility.BACK_SOON_VISIBILITY || 
                                          this.visibility === joyr.constants.visibility.COMMING_SOON_VISIBILITY;
        };

        Product.prototype.applyVipPriceLogic = function(size){
            if(size.vipPrice && size.price != size.vipPrice){
                size.oldPrice = size.price;   
                size.price = size.vipPrice;            
            }
        };

        Product.prototype.applyAllPriceLogic = function(){
            var _this = this;
            if(inditex && inditex.iUserJSON && inditex.iUserJSON.showPrivateSale){
                _.each(_this.activeDetail.colors,function(color){
                    _.each(color.sizes,function(size){
                        _this.applyVipPriceLogic(size);
                    });    
                });
            }
        };

        Product.prototype.setColor = function(color) {
            var _this = this;
            var colorId = null;

            // TODO
            _this.state.selectedSize = null;

            if (color){
                if(typeof color === 'object'){
                    colorId = color.id;
                } else {
                    colorId = color;
                }
            } else if(_this.state.selectedColor) {
                colorId = _this.state.selectedColor.id;
            } else if(_this.pendingColor){
                colorId = _this.pendingColor;
            } else if(_this.activeDetail && _this.activeDetail.colors && _this.activeDetail.colors.length>0){
                colorId = _this.activeDetail.colors[0].id;
            }  

            if(_this.sku && _this.activeDetail && _this.activeDetail.colors){
                // Preseleccionamos un MOCACOTA con el Sku del item
                _.each(_this.activeDetail.colors, function(color, i) {
                    _.each(color.sizes, function(size) {
                        if(size.sku == _this.sku){
                            _this.state.selectedColorIndex = i;
                            _this.state.selectedColor = color;
                            _this.state.selectedSize = size;
                        }
                    });
                });
            } else if(colorId && _this.activeDetail && _this.activeDetail.colors){
                _.each(_this.activeDetail.colors, function(color, i) {
                    if (color.id == colorId) {
                        _this.state.selectedColorIndex = i;
                        _this.state.selectedColor = color;
                    }
                });
            } else {
                _this.state.selectedColorIndex = 0;
                _this.state.selectedColor = null;
                _this.state.selectedSize = null;
            }         
            
            // TODO REFACTOR deseleccionar color que no tiene visibilidad o seleccionar el primero visible
            var index = 0;
            while ( (!_this.state.selectedColor || 
                      _this.state.selectedColor && _this.state.selectedColor.visibility === 'hidden' ) && 
                    ( _this.activeDetail && _this.activeDetail.colors && _this.activeDetail.colors.length >= index ) ) 
            {
                _this.state.selectedColorIndex = index;
                _this.state.selectedColor = _this.activeDetail.colors[index];
                index++;
            }
            
            return _this;
        };

        // Función para añadir el set de la imagen principal al state del producto
        Product.prototype.addSet = function(primaryImage) {

            var _this = this;
            var pattern = new RegExp(/.*(V|I)\/\d\/\d\/[p|b]\/\d{4}\/\d{3}\/\d{3}\/\d{1,2}\//);

            // Si encontramos el patrón en la URL
            if(pattern.test(primaryImage)) {
                
                // Cogemos el valor del set
                var url = primaryImage.match(pattern)[0];
                var splitedUrl = url.split('/');
                var set = splitedUrl.pop() || splitedUrl.pop();

                _this.state.imageSet = set;
            }
            // Sino, añadimos el set por defecto
            else {
                _this.state.imageSet = inditex.iStoreJSON.details.xmedia.defaultStoreSet.toString();
            } 
        };

        Product.prototype.selectSize = function(size) {
            var _this = this;
            _this.state.selectedSize = size;
            return _this;
        };

        Product.prototype.getCategory = function() {};

        Product.prototype.isUniqueSize = function() {};

        Product.prototype.setRelated = function(value) {
            this.isRelated = value || false;
        };        

        Product.prototype.setConfigProduct = function() {
            var _this = this;
            var conf = {
                navigate: true,
                details: true,
                moreColors: true,
                detailButton: _this.isBundleBean,
                pricesBundle: _this.isBundleBean,
                options: true,
                navigateCustomId: false,
                autoPlayVideo: true,
                waitClick: false,
                hasNameButton: false,
                typeCarrousel: {
                    isLook: false,
                    isColors: false,
                    isDefault: false
                }
            };

            _.each(_this.attributes, function (attr) {
                if (attr.name === 'BANNER_PRODUCT') {
                    conf.navigate = false;
                    conf.details = false;
                    conf.options = false;
                    conf.autoPlayVideo = false;
                    conf.waitClick = true;
                    _this.state.isFakeBanner = true;
                    _this.state.isProduct = false;
                }
                if(attr.type === 'XCUSTOMIZABLE'){
                    conf.options = false;
                    _this.state.xcustomization = true;
                    _this.state.xcustomizationDate = attr.name === 'ESTAMPADO_PERFUME' ? true : false;
                }
                if(attr.name.indexOf('BANNERLINK') > -1){
                    conf.navigateCustomId = attr.value;
                }
                if (attr.name === 'BUNDLE_CARROUSEL' || attr.name === 'BUNDLE_CARROUSEL_LOOK' || attr.name === 'BUNDLE_CARROUSEL_COLORS') {
                    let isLook = attr.name === 'BUNDLE_CARROUSEL_LOOK';
                    let isColors = attr.name === 'BUNDLE_CARROUSEL_COLORS';
                    conf.typeCarrousel = {
                        isLook: isLook,
                        isColors: isColors && !isLook,
                        isDefault: !isColors && !isLook
                    };
                    
                    _this.state.isCarrousel = !isExplorer;
                    _this.state.isProduct = !_this.state.isCarrousel;
                    _this.state.bundleProducts = _this.getBundleProducts(_this.bundleProductSummaries);
                }
            });

            _this.state.conf = conf;
            return _this;
        };

        /**
         * @ngdoc method
         * @name getUrl
         * @methodOf  common.service:ProuctClass
         * @description
         * Given a ProductClass Object. It will return the correct url for this product.
         * It has 2 variants.
         * - SEO URLS (new way) in this case the info is provided by the encodeProductUrl param
         * - Old URLS: in this case the object calls the  joyr function to construct the URL
         */
        Product.prototype.getUrl = function() {
            var url;

            if (ItxConfigurationSvc.isSeoUrlsEnabled()) {

                var params = joyr.utils.extend({}, {
                    storeId: inditex.iStoreId,
                    langId: inditex.iLangId,
                    catalogId: inditex.iCatalogId,
                    productId: this.id,
                });

                sessionStorage.setItem('mdLastProduct', params, inditex.encodeProductUrl);
                
                url = inditex.encodeProductUrl({
                    action: 'ItxProductPage',
                    params: params
                }, false, this.productUrl, this.productUrlParam);

                url =  joyr.utils.getCommonPageUrl('ItxHomePage', false, false)+this.productUrl;
            } else {

                if (this.state && this.state.selectedColor) {
                    url = this.getProductUrl(this.id, this.categoryId, this.name, false, false, this.state.selectedColor.id);
                } else {
                    url = this.getProductUrl(this.id, this.categoryId, this.name, false, false, null);
                }

                if (this.categoryId) {
                    if(url.indexOf('?')>-1){
                        url = url + '&categoryId=' + this.categoryId;
                    }
                    else{
                        url = url + '?categoryId=' + this.categoryId;
                    }
                }
            }

            return url;
        };

        /**
         * @ngdoc method
         * @name getUrlByStoreId
         * @methodOf  common.service:ProuctClass
         * @description
         * Given a ProductClass Object. It will return the correct url for this product.
         * It has 2 variants.
         * - SEO URLS (new way) in this case the info is provided by the encodeProductUrl param
         * - Old URLS: in this case the object calls the  joyr function to construct the URL
         */
        Product.prototype.getUrlByStore = function (storeId, langId) {
            var url;
            if (ItxConfigurationSvc.isSeoUrlsEnabled()) {

                var params = joyr.utils.extend({}, {
                    storeId: storeId,
                    langId: langId,
                    catalogId: inditex.iCatalogId,
                    productId: this.id,
                });

                sessionStorage.setItem('mdLastProduct', params, inditex.encodeProductUrl);
                
                url = inditex.encodeProductUrl({
                    action: 'ItxProductPage',
                    params: params
                }, false, this.productUrl, this.productUrlParam);

                url =  joyr.utils.getCommonPageUrl('ItxHomePage', false, false)+this.productUrl;
            } else {

                if (this.state && this.state.selectedColor) {
                    url = this.getProductUrlByStore(this.id, this.categoryId, this.name, false, false, this.state.selectedColor.id, null, storeId, langId);
                } else {
                    url = this.getProductUrlByStore(this.id, this.categoryId, this.name, false, false, null, null, storeId, langId);
                }

                if (this.categoryId) {
                    if(url.indexOf('?')>-1){
                        url = url + '&categoryId=' + this.categoryId;
                    }
                    else{
                        url = url + '?categoryId=' + this.categoryId;
                    }
                }
            }

            return url;
        };


        // Product.prototype.checkIsBanner = function() {
        //     return this.onSpecial && this.type === joyr.constants.product.PRODUCT_BEAN;
        // };
        
        Product.prototype.getBasicTypes = function(){
            return _.filter(this.xmediaImages, function(image){        
                return [
                    ItxConstants.imageTypes.main, 
                    ItxConstants.imageTypes.alternative, 
                    ItxConstants.imageTypes.siluet,
                    ItxConstants.imageTypes.siluet2, 
                    ItxConstants.imageTypes.altImg
                ].indexOf(image.clazz)>-1;              
            });
        };

        Product.prototype.setLayoutProduct = function(classElemetWrapperImages) {
            var _this = this;            

            if(!_this.fetched){
                console.log('NO TENEMOS LA PETICION DE DETALLE');
            }
            
            var width;
            if(classElemetWrapperImages && typeof classElemetWrapperImages === 'string'){
                if(!window.productPopupOpen) {
                    width = $(classElemetWrapperImages).width();
                } else {
                    width = $('.ngdialog-content ' + classElemetWrapperImages).width();
                }
            }

            if(!width || !_.isNumber(width)){
                width = 600;
                console.error('*** PRODUCT LAYOUT SERVICE no sabemos el ancho del contenedor de la imagen - SET DEFAULT AKAMAI 600 ***');
            }

            var ArrayImages = ItxUtilsFct.getProductXmediaImagesData(_this, ItxConstants.xmediaLocations['productPage'], width);
            
            _this.layoutProduct = ProductLayoutSvc.getLayoutProductPage(ArrayImages, width);

             // Si no es un Bundle y hay imágenes, añadimos el Set en base a la primera de ellas
             if(ArrayImages.length > 0&& _this.gridElemType !== 'BUNDLE') {
                _this.addSet(ArrayImages[0].url);
            }

        };
        
        function Layout( 
            className = '', 
            classType = 'box-single', 
            classRatio = 'rat-2-3',
            imageUrl = null, 
            imageSecondUrl = null, 
            swiper = true 
        ) {
            this.className = className
            this.classType = classType
            this.classRatio = classRatio
            this.imageUrl = imageUrl
            this.imageSecondUrl = imageSecondUrl
            this.swiper = swiper            
        }

        Product.prototype.getSetFromImagePath= function(pathFile , color ){

            pathFile =  pathFile.split('/');
           pathFile.pop();
           var lastFolder =   pathFile.pop(); 
           var set;
           if(lastFolder.length ==2){
                set = parseInt(lastFolder);
           }else{
               set = 0;
           }
           return color.xmediaItems.find(item =>  item.set === set);
        };
        Product.prototype.getColorFromImagePath= function( pathFile, xmedia){
            pathFile =  pathFile.split('/');
           pathFile.pop();
          
           var  colorFolder =   pathFile.pop(); 
           //Si es = 2, es un estilismo, lo borramos
           if(colorFolder.length ==2){
            colorFolder =   pathFile.pop(); 
           }
           return xmedia.find(colors => colors.colorCode ===  colorFolder);
        };

        Product.prototype.setLayout = function(location, element) {
           
            var _this = this;
            var layout= {
                'two-columns': new Layout(),
                'four-columns': new Layout()
            };

            _this.isVideo = false;
            _this.xmediaImages = ItxUtilsFct.getProductXmediaImagesData(_this, location, 500);
            _this.locationPage = location;

            if(_this.state.isBanner){
                _this.layout = {
                    'two-columns': new Layout('col-xs-12', 'box-double', 'rat-3-2', null, null, false),
                    'four-columns': new Layout('col-xs-12', 'box-double', 'rat-2-3', null, null, false)
                };
                _this.layout['four-columns'].disabled = true;
                return;
            }

            // Si es video  

            
            if (_this.xmediaImages[0] && _this.xmediaImages[0].format === ItxConstants.xmediaFormats.MP4 ) {

                //REVISAMOS QUE NO SEA CASO m3U8
                //para un sed dado..
                
                var mediaId = _this.xmediaImages[0].url.split('/').pop().split('.')[0];
                console.log(mediaId);
                mediaId = mediaId.split('_')
                mediaId.pop();
                mediaId = mediaId.join('_');
                var color =_this.getColorFromImagePath(_this.xmediaImages[0].url, _this.detail.xmedia);
                var set = _this.getSetFromImagePath(_this.xmediaImages[0].url, color)

                var elem = set.medias.filter(media=> ( media.idMedia ==  mediaId + '_') && media.format === 6);
                
                if(elem && elem.length > 0){
                    _this.videoSrc = _this.xmediaImages[0].url;
                    if(_this.videoSrc.includes('_12.')){
                        _this.videoSrc =  _this.videoSrc.replace('_12.','_16.');
                    }
                    _this.videoImg = _this.videoSrc.replace('.mp4', '.jpg');
                    _this.videoSrc = _this.videoSrc.replace('.mp4', '.m3u8');
                } else{

                    if(!_this.xmediaImages[0].extraInfo){
                        _this.xmediaImages[0].extraInfo = {};
                    }
                    _this.videoCode = _this.xmediaImages[0].extraInfo.videoCode;
                    _this.videoSrc = _this.xmediaImages[0].url;
                    // TODO fix image poster video, no debería llegar con _12 en el nuevo desarrollo ECOMDUTI-9669
                    if(_this.xmediaImages[0].url.includes('_12.mp4')){
                        _this.videoImg = _this.xmediaImages[0].url.replace('_12.mp4','_16.jpg');
                    } else {
                        _this.videoImg = _this.xmediaImages[0].url.replace('.mp4','.jpg');
                    }
                }
                _this.isVideo = true;
            }
            // Si es video HLS
            if (_this.xmediaImages[0] && _this.xmediaImages[0].format === 6 ) {
                if(!_this.xmediaImages[0].extraInfo){
                    _this.xmediaImages[0].extraInfo = {};
                }
                
                _this.videoSrc = _this.xmediaImages[0].url;
                _this.videoImg = _this.videoSrc.replace('.m3u8', '.jpg');
               
               _this.isVideo = true;
            }
                
            if(ItxUtilsFct.isXmediaEnabled(_this) && _this.xmediaImages.length>0) {
                    
                var basicImages = _this.getBasicTypes();
                var firstImage;
                if(_this.activeDetail.defaultImageType){
                    firstImage = _.find(_this.xmediaImages,function(img){
                        return img.url.indexOf(_this.activeDetail.defaultImageType)>-1;
                    });
                }
                if(!firstImage){
                    firstImage = _this.xmediaImages[0];
                }

                //PARA 4 LA BASIC..
                if(basicImages[0]){
                    layout['four-columns'].imageUrl = basicImages[0].url;
                } else {
                    layout['four-columns'].imageUrl = '';
                }
                
                if(basicImages[1]){
                    layout['four-columns'].imageSecondUrl = basicImages[1].url;
                }

                //LAYOUT DOUBLE..
                if(firstImage.clazz === ItxConstants.imageTypes.doubleBox || firstImage.clazz === ItxConstants.imageTypes.doubleBoxBanner) {
                    layout['two-columns'].imageUrl = firstImage.url;
                    layout['two-columns'].classType = 'box-double';
                    layout['two-columns'].classRatio = 'rat-3-2';
                    layout['two-columns'].swiper = false;
                }

                //LAYOUT SUPER BOX..
                else if(firstImage.clazz === ItxConstants.imageTypes.superBox || firstImage.clazz === ItxConstants.imageTypes.superBoxBanner) {
                    layout['two-columns'].imageUrl = firstImage.url;
                    layout['two-columns'].classType = 'box-super';
                    layout['two-columns'].swiper = false;
                } 

                //LAYOUT SPECIAL IMAGE
                else if(firstImage.clazz === ItxConstants.imageTypes.altImg ) {
                    layout['two-columns'].imageUrl = firstImage.url;
                }
                
                //LAYOUT VERTICAL BOX..
                else if(firstImage.clazz === ItxConstants.imageTypes.verticalBox ) { 
                    layout['two-columns'].imageUrl = firstImage.url;
                    layout['two-columns'].classType = 'box-vertical';
                    layout['two-columns'].swiper = false;
                    _this.config.isVerticalBox = true;
                }  

                //LAYOUT NORMAL..
                else {
                    var mainBasicImage, secondBasicImage;
                    if(_this.activeDetail.defaultImageType && firstImage &&  firstImage.url.indexOf(_this.activeDetail.defaultImageType) ){
                        mainBasicImage = firstImage;
                        secondBasicImage = basicImages[0];

                        if(mainBasicImage.url === secondBasicImage.url){
                            secondBasicImage = basicImages[1];
                        }
                    }
                    else{
                        mainBasicImage = basicImages[0];
                        secondBasicImage = basicImages[1];
                    }
                    if(secondBasicImage && (mainBasicImage.url === secondBasicImage.url)){
                        secondBasicImage = basicImages[1];
                    }
                    
                    layout['two-columns'].imageUrl = mainBasicImage.url;
                    
                    //SI NO ES VIDEO
                    if(mainBasicImage.format !== 6 && mainBasicImage.format !== 4){
                        layout['four-columns'].imageUrl = mainBasicImage.url;
                    }
                    if(secondBasicImage){
                        layout['two-columns'].imageSecondUrl = secondBasicImage.url;
                        if(secondBasicImage.format !== 6 && secondBasicImage.format !== 4){
                            layout['four-columns'].imageSecondUrl = secondBasicImage.url;
                        }
                    }
                }
            }
            else{
                   
                //NO XMEDIA... Miramos configuración de gesticor ( configurado previamente)
                //SI tiene atributo doubleBox..
                if( _this.config && _this.config.isDoubleBox){
                    layout['two-columns'].classType = 'box-double';
                    layout['two-columns'].swiper = false;
                }
                
                //Sino, campos x defecto 
                layout['two-columns'].imageUrl = _this.getImageNoXmedia();
                layout['two-columns'].imageSecondUrl = _this.getImageNoXmedia(true);
                layout['four-columns'].imageUrl = _this.getImageNoXmedia();
                layout['four-columns'].imageSecondUrl = _this.getImageNoXmedia(true);
            }
            
            if(_this.state.isCarrousel){
                layout['two-columns'].classType = 'box-double';
            }
            
            if(_this.state.isFakeBanner){
                layout['four-columns'].disabled = true;
            }

            _this.layout = layout;
        };

        /**
         * @description getMainImage est
         * @deprecated No se está utilizando. Dejamos por temporalmente..
         * 
         * @param {*} altImage 
         */
        Product.prototype.getMainImage = function(altImage) {
            
            var _this = this;

            var xmediaEnabled = (inditex.iStoreJSON.details.xmedia !== null) && (_this.activeDetail.xmedia !== null);
            var mainImage;
               
            xmediaEnabled = false;
            if (xmediaEnabled) {
                //_this.setColor();
                _this.setXmediaDefaultSet();
                var obj = ItxUtilsFct.getProductXmediaImagesData(_this, ItxConstants.xmediaLocations.categoryPage, 600);

                mainImage = obj[0].url;
            } else {
                mainImage = _this.getImageNoXmedia(altImage);
            }

            return mainImage;
        };

        /**
         * @description Función extraída de getMainImage. 
         * Gestiona la parte de  extraer la imágen del producto cuando XMEDIA no está activo.
         * @param {*} notAltImg 
         */
        Product.prototype.getImageNoXmedia = function(notAltImg) {
            var image;
            var _this = this;
            var  type,
            mainImageIndex = 0,
            size;

            if(_this.activeDetail.colors[0]){
                image = _this.activeDetail.colors[0].image;
            }
            
            if(!image && _this.bundleProductSummaries && _this.bundleProductSummaries.length != 0){
                image = _this.bundleProductSummaries[0].detail.colors[0];
            }

            if (!image) {
                console.error('No image for this product', _this);
                return;
            }

            //Get type (Default to grid if not specified)
            if (_this.imageType) {
                type = _this.imageType;
            } else {
                if (_this.config &&
                    _this.config.isDoubleBox &&
                    (_this.layout !== ItxConstants.categoryLayout.FOUR_COLUMNS || ItxScreenSizeSvc.is('xs'))) {
                    type = ItxUtilsFct.getImageType('doubleBox');
                } else {
                    type = mainImageIndex === 1 ?
                        ItxUtilsFct.getImageType('alternative') :
                        (!notAltImg && _this.config &&
                            (_this.config.altImg || _this.config.altImage)) ?
                        ItxUtilsFct.getImageType('altImg') : ItxUtilsFct.getImageType('main');
                }
            }

            //Get size (Default to grid if not specified)
            if (_this.imageSize) {
                size = _this.imageSize;
            } else {
                size = 'grid';
            }

            var mainImage = inditex.getProductImageUrls(image, type, ItxUtilsFct.getImageSize(size))[0];
            
            return mainImage;
        };

        Product.prototype.getProductUrl =  function (productId, categoryId, keyword, isMobile, isAjax, colorId, extraParams) {
            if (!productId) {
                throw new ReferenceError('Missing parameter: productId');
            }
            var params;
            if (ItxConfigurationSvc.isSeoUrlsEnabled()) {
                params =  {
                    storeId: inditex.iStoreId,
                    langId: inditex.iLangId,
                    catalogId: inditex.iCatalogId,
                    productId: this.id,
                };                
                
                var url = inditex.encodeProductUrl({
                    action: 'ItxProductPage',
                    params: params
                }, false, this.productUrl, this.productUrlParam);
                
                url = this.productUrl;
                
                return url;
            } else {
                params = joyr.utils.extend(extraParams, {
                    storeId: inditex.iStoreId,
                    langId: inditex.iLangId,
                    catalogId: inditex.iCatalogId,
                    categoryId: categoryId ? categoryId : 0,
                    productId: productId,
                    keyWord: keyword,
                    colorId: colorId
                });
                return inditex.encodeUrl({
                    action: 'ItxProductPage',
                    params: params,
                    isMobile: isMobile ? isMobile : false,
                    isAjax:  isAjax ? isAjax : false
                });
            }
        };


        Product.prototype.getProductUrlByStore =  function (productId, categoryId, keyword, isMobile, isAjax, colorId, extraParams, storeId, langId) {
            if (!productId) {
                throw new ReferenceError('Missing parameter: productId');
            }
            var params;
            if (ItxConfigurationSvc.isSeoUrlsEnabled()) {
                params =  {
                    storeId: storeId,
                    langId: langId,
                    catalogId: inditex.iCatalogId,
                    productId: this.id,
                };                
                
                var url = inditex.encodeProductUrl({
                    action: 'ItxProductPage',
                    params: params
                }, false, this.productUrl, this.productUrlParam);
                
                url = this.productUrl;
                
                return url;
            } else {
                params = joyr.utils.extend(extraParams, {
                    storeId: storeId,
                    langId: langId,
                    catalogId: inditex.iCatalogId,
                    categoryId: categoryId ? categoryId : 0,
                    productId: productId,
                    keyWord: keyword,
                    colorId: colorId
                });
                return inditex.encodeUrl({
                    action: 'ItxProductPage',
                    params: params,
                    isMobile: isMobile ? isMobile : false,
                    isAjax:  isAjax ? isAjax : false
                });
            }
        };

  
        Product.prototype.setXmediaDefaultSet = function() {
            if (!this.activeDetail.xmediaDefaultSet && this.parent && this.parent.detail && this.parent.detail.xmediaDefaultSet) {
                this.activeDetail.xmediaDefaultSet = this.parent.detail.xmediaDefaultSet;
            }
        };

        Product.prototype.setElementType = function () {
            var _this = this;
            switch (_this.gridElemType) {
                case 'BUNDLE':
                    _this.activeDetail = _this.detail;
                    _this.isBundleBean = true;
                    if(_this.activeDetail.xmedia && _this.activeDetail.xmedia.length>1){
                        var validXmedia = _this.activeDetail.xmedia.find(function(xmediaColor){
                            return xmediaColor.colorCode === _this.mainColorid;
                        })
                        _this.activeDetail.xmedia = [validXmedia];
                    }
                    break;
                case 'MOCACO':
                    if(_this.bundleProductSummaries && _this.bundleProductSummaries.length != 0){
                        _this.activeDetail = _this.bundleProductSummaries[0].detail;
                    } else {
                        _this.activeDetail = _this.detail;
                    }
                    _this.setColor();         
                    break;
                case 'ESTILISMO':
                    if(_this.bundleProductSummaries && _this.bundleProductSummaries.length != 0){
                        _this.activeDetail = _this.bundleProductSummaries[0].detail;
                    } else {
                        _this.activeDetail = _this.detail;
                    }
                    _this.setColor();
                     // Guardamos el color que viene en el set
                    if(_this.activeDetail.colors[0]){
                        _this.state.idSetColor = _this.activeDetail.colors[0].id;
                    }                    
                    break;
                case 'BANNER':
                    _this.activeDetail = _this.detail;   
                    _this.state.isBanner = true;
                    break;
                default:
                    if(_this.detail){
                        if(_this.activeDetail && _this.activeDetail.xmediaDefaultSet){
                            _this.detail.xmediaDefaultSet = _this.activeDetail.xmediaDefaultSet;
                        }
                        _this.activeDetail = _this.detail;
                    }
                    
                    _this.setColor();
                    break;
            }

            return _this;
        };

        // Lógica para los productos de tipo perfume
        Product.prototype.isPerfum = function() {

            var _this = this;          

            // Si el productio tiene PAO, se considera perfume
            if(_this.activeDetail && _this.activeDetail.pao) {

                // Construimos los atributos necesarios
                _this.perfum = {
                    pao: _this.activeDetail.pao,
                    productPacksMessage: '', 
                    ingredients: _this.activeDetail.ingredients,
                    warnings: _this.activeDetail.warnings,
                    measurement: _this.activeDetail.measurementUnit ? 
                        (_this.activeDetail.measurementUnit.type + _this.activeDetail.measurementUnit.description): false,
                    pack: _this.activeDetail.pack
                }                
                // Mostramos un mensaje u otro en función de la cantidad de Packs que tenga
                if(_this.activeDetail.pack > 1) {
                    _this.perfum.productPacksMessage = 'ItxProductView.moreThanOnePack';
                }
                else {
                    _this.perfum.productPacksMessage = 'ItxProductView.onlyOnePack';
                }
            }

            return _this;
        };

        Product.prototype.getMocacocode = function() {
            var _this = this;
            var moca, partials, colorId;
            
            if(_this.activeDetail.colors && _this.activeDetail.colors.length > 0){
                colorId = _this.activeDetail.colors[ _this.state.selectedColorIndex ].id;
            } else {
                colorId = _this.mainColorid;
            }
            //color = product.activeDetail.colors[ product.state.selectedColorIndex ];
            partials = _this.activeDetail.reference.split('-');
            moca = partials[0] + colorId;
            return moca.substring(1,11);
        };

        Product.prototype.getBundleProducts = (products) => {
            let arrayP = [];
            
            if(!products || !products[0]){
                return arrayP;
            }
            
            products.forEach(p=>{
                if (p.gridElemType === "MOCACO" && p.bundleProductSummaries.length > 0) {
                    p.bundleProductSummaries[0].detail.colors.slice(0,1);
                    var mocacoBundle = new Product(p);
                    var findStockSize = false;
                    _.map(mocacoBundle.activeDetail.colors[0].sizes, function (size) {
                        if (size.visibilityValue === 'SHOW') { 
                            findStockSize = true
                        }
                    });
                    if(findStockSize){
                        arrayP = arrayP.concat(mocacoBundle);
                    }
                } else {
                    arrayP = arrayP.concat(new Product(p));
                }
            });

            if(arrayP.length === 1){
                setConfigRollover(arrayP[0], false);
            } else {
                arrayP.forEach(newProduct=>{
                    setConfigRollover(newProduct,true);
                });
            }
                             
            return arrayP;
        };

        let setConfigRollover = (product,bolean) => {
            if (product.config){
                product.config.isNoRollover = bolean;
            } else {
                product.config = { isNoRollover: bolean };
            }
        }
        return Product;
    }

})(window);
